import psHttp, { RequestChannel, psHttp$ } from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
const fetchChannelWorkspace = new RequestChannel(psHttp$);
/**
 * 获取列表数据
 */
export function getViewDataApi({ space_id, folder_id, efqid, data_type, page, qid, sort, view_type, cond, highlight }) {
    return fetchChannelWorkspace
        .requestAsPromise({
        url: `${workspaceApiUrlPrefix}/${space_id}/folder/${folder_id}/data`,
        method: 'POST',
        data: {
            data_type,
            efqid,
            page,
            qid,
            cond,
            sort,
            view_type,
            highlight,
        },
        transformCode: true,
    })
        .then(({ data }) => {
        return data || {};
    });
}
/**
 * 复制
 */
export function copyViewDataApi({ space_id, from_folder_id, doc_ids, refiner, select_mode, to_folder_id, start, end, sort, data_type, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/from_folder/${from_folder_id}/copy-data`,
        method: 'POST',
        data: {
            data_type,
            doc_ids,
            refiner,
            select_mode,
            to_folder_id,
            start,
            end,
            sort,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 移动
 */
export function moveViewDataApi({ data_type, space_id, from_folder_id, doc_ids = [], refiner = {}, select_mode, to_folder_id, start, end, sort, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/from_folder/${from_folder_id}/move-data`,
        method: 'POST',
        data: {
            data_type,
            doc_ids,
            refiner,
            select_mode,
            to_folder_id,
            start,
            end,
            sort,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 删除
 */
export function deleteViewDataApi({ folder_id, doc_ids = [], refiner = {}, select_mode, sort, start, end, data_type, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/delete-data`,
        method: 'DELETE',
        data: {
            data_type,
            doc_ids,
            refiner,
            select_mode,
            start,
            end,
            sort,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 更新已读未读状态
 */
export function updateViewDataReadStatusApi({ folder_id, doc_ids = [], refiner = {}, select_mode, read_status, start, end, sort, data_type, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/data-read-status/batch-mark`,
        method: 'POST',
        data: {
            data_type,
            doc_ids,
            refiner,
            select_mode,
            read_status,
            start,
            end,
            sort,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
